<template>
  <div class="redirect-item columns" v-if="!deleted">
    <div class="centered column delete-column">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDelete"/>
    </div>
    <div class="column">
      <b-input
      v-model="redirect.fromUrl"
      placeholder="Введите исходный URL"
      :disabled="!editMode" />
    </div>
    <div class="column">
      <b-input
      v-model="redirect.toUrl"
      placeholder="Введите целевой URL"
      :disabled="!editMode" />
    </div>
    <div class="centered column edit edit-column">
      <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEdit" v-if="!editMode"/>
      <a class="button is-info" v-else @click="handleUpdateRedirect">Сохранить</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'RedirectItem',
  data () {
    return {
      editMode: false,
      newPassword: '',
      deleted: false
    }
  },
  created () {
    if (this.redirect.isNew) {
      this.editMode = true
    }
  },
  props: {
    redirect: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteRedirect', 'addRedirect', 'updateRedirect']),
    toggleEdit () {
      this.editMode = !this.editMode
    },
    toggleChangePassword () {
      this.passwordChangeMode = !this.passwordChangeMode
    },
    handleDelete () {
      if (!this.redirect.isNew) {
        this.deleteRedirect(this.redirect.id)
      }
      this.deleted = true
    },
    handleUpdateRedirect () {
      if (this.redirect.isNew) {
        this.addRedirect(this.redirect)
      } else {
        this.updateRedirect(this.redirect)
      }

      this.toggleEdit()
    }
  }
}
</script>

<style scoped>
.redirect-item {
  background: #eee;
  margin: 5px 0;
  padding: 10px;
  border-radius: 5px;
}
.delete-icon {
  position: initial;
}
img {
  height: 32px;
  width: 32px;
  margin: 0 8px;
  vertical-align: text-top;
}
.change-password {
  padding: 5px 15px;
}
.column {
  padding: 0;
}
.edit-icon {
  cursor: pointer;
  float: right;
}
.delete-column {
  max-width: 60px;
}
.edit-column {
    max-width: 110px;
}
.link {
  text-align: left;
  display: inline-block;
}
.control {
  margin-right: 15px;
}
.apply-icon {
  background: #006DF0;
  border-radius: 25px;
  padding: 5px;
  cursor: pointer;
}
.hide-password-input {
  height: 32px;
  min-width: 32px;
  margin: 0 8px 0 0;
}
form {
  margin: 0 15px 0 0;
}
</style>
<style>
.redirect-item input:disabled,
.is-disabled input{
  background: #eee !important;
  border: none !important;
  color: #000 !important;
}
.is-disabled .el-icon-caret-top {
  display: none;
}
.redirect-item .error input {
  border-color: red !important;
}
</style>



// WEBPACK FOOTER //
// RedirectItem.vue?ca5848a2